/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Terms_Save_Changes_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to save some changes: {error}" |
*
* @param {Knp_Terms_Save_Changes_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_save_changes_failed = /** @type {((inputs: Knp_Terms_Save_Changes_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Save_Changes_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l’enregistrement de certaines modifications : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Einige Änderungen konnten nicht gespeichert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile salvare alcune modifiche: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось сохранить некоторые изменения: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudieron guardar algunos cambios: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`部分更改保存失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`一部の変更を保存できませんでした: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`कुछ परिवर्तन सहेजने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao salvar algumas alterações: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to save some changes: ${i?.error}`)
});